import { BsMedium } from "react-icons/bs";
import { RiTwitterXFill } from "react-icons/ri";
import { FaRegEnvelope, FaInstagram } from "react-icons/fa6";
import { FaGithub, FaLinkedin, FaWhatsapp } from "react-icons/fa";

const Header = () => {
  return (
    <header className="w-full">
      <nav className="container px-4 mx-auto flex flex-col md:flex-row justify-between items-center py-1.5 md:py-2 gap-y-1 md:gap-y-0">
        <div className="w-full md:w-auto flex justify-center md:justify-start">
          <h1 className="text-[28px] sm:text-4xl md:text-5xl xl:text-5xl 2xl:text-6xl font-extrabold uppercase tracking-wider">
            <span className="outlined-text text-transparent">Ashraful</span>{" "}
            <span className="outlined-text-second text-transparent">Islam</span>
          </h1>
        </div>
        <div className="flex flex-wrap justify-center items-center gap-x-4 sm:gap-x-5 md:gap-x-4 lg:gap-x-6 text-[18px] sm:text-[20px] lg:text-[19px] xl:text-[18px] 2xl:text-[22px]">
          <a
            title="Github"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.github.com/ashraful2880"
            className="text-gray-300 hover:text-white hover:scale-110 duration-200 ease-in-out"
          >
            <FaGithub />
          </a>
          <a
            target="_blank"
            title="Linkedin"
            rel="noopener noreferrer"
            href="https://www.linkedin.com/in/islam-ashraful1/"
            className="text-gray-300 hover:text-white hover:scale-110 duration-200 ease-in-out"
          >
            <FaLinkedin />
          </a>
          <a
            title="X"
            target="_blank"
            rel="noopener noreferrer"
            href="https://x.com/IslamAshraful80"
            className="text-gray-300 hover:text-white hover:scale-110 duration-200 ease-in-out"
          >
            <RiTwitterXFill />
          </a>
          <a
            target="_blank"
            title="Instagram"
            rel="noopener noreferrer"
            href="https://www.instagram.com/islam.ashraful1/"
            className="text-gray-300 hover:text-white hover:scale-110 duration-200 ease-in-out"
          >
            <FaInstagram />
          </a>
          <a
            target="_blank"
            title="WhatsApp"
            rel="noopener noreferrer"
            href="https://wa.me/8801974238487"
            className="text-gray-300 hover:text-white hover:scale-110 duration-200 ease-in-out"
          >
            <FaWhatsapp />
          </a>
          <a
            title="Medium"
            target="_blank"
            rel="noopener noreferrer"
            href="https://medium.com/@contact.ashraful1"
            className="text-gray-300 hover:text-white hover:scale-110 duration-200 ease-in-out"
          >
            <BsMedium />
          </a>
          <a
            title="Gmail"
            href="mailto:contact.ashraful1@gmail.com"
            className="text-gray-300 hover:text-white hover:scale-110 duration-200 ease-in-out"
          >
            <FaRegEnvelope />
          </a>
        </div>
      </nav>
    </header>
  );
};

export default Header;
